module.exports = __webpack_public_path__ + "static/carbon-ab288f80dd10f94fa96a71834ca9ea3f.png";